export default {
  ADD_ADDITINAL_PAGES (state, pages) {
    state.pages = pages
  },
  ADD_NEW_ADDITIONAL_PAGE (state, page) {
    state.pages.unshift(page)
    state.page = page
  },
  DELETE_ADDITIONAL_PAGE  (state, id) {
    state.page = null
    state.pages = state.pages.filter(d => d.id !== id)
  },
  ADD_ADDITINAL_PAGE (state, page) {
    state.page = page
    state.pages = state.pages.filter(p => p.isNew !== true)
  },
  UPDATE_ADDITIONAL_PAGE (state, page) {
    state.page = page
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/additionalPages.js